import { HEAD_DOCTOR_PATHS } from '../../doctor/doctorPaths';

/** Liens de navigation des rapports — ordre d’affichage dans la sous-barre. */
export const REPORTS_NAV_ITEMS = [
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_SYNTHESE,
    end: true,
    labelKey: 'SUB_SYNTHESE',
    navKey: 'statistiquesSynthese'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_CONSULTATIONS,
    end: false,
    labelKey: 'SUB_CONSULTATIONS',
    navKey: 'statistiquesConsultations'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_JOURS_REPOS,
    end: false,
    labelKey: 'SUB_REPOS',
    navKey: 'statistiquesRepos'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_MORBIDITE,
    end: false,
    labelKey: 'SUB_MORBIDITE',
    navKey: 'statistiquesMorbidite'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_PATHOLOGIES,
    end: false,
    labelKey: 'SUB_PATHOLOGIES',
    navKey: 'statistiquesPathologies'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_ORDONNANCES,
    end: false,
    labelKey: 'SUB_ORDONNANCES',
    navKey: 'statistiquesOrdonnances'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_MEDICAMENTS,
    end: false,
    labelKey: 'SUB_MEDICAMENTS',
    navKey: 'statistiquesMedicaments'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_SOINS,
    end: false,
    labelKey: 'SUB_SOINS',
    navKey: 'statistiquesSoins'
  },
  {
    to: HEAD_DOCTOR_PATHS.STATISTIQUES_EXAMENS,
    end: false,
    labelKey: 'SUB_EXAMENS',
    navKey: 'statistiquesExamens'
  }
];

export const REPORTS_PERIOD_PRESETS = [
  { key: '7d', days: 7, labelKey: 'PRESET_7D' },
  { key: '30d', days: 30, labelKey: 'PRESET_30D' },
  { key: '90d', days: 90, labelKey: 'PRESET_90D' },
  { key: '12m', days: 365, labelKey: 'PRESET_12M' }
];
